/* Sort the complete filtered collection BEFORE pagination, not just the current page. */
(() => {
  if (window.wombatStockCatalogStarted) return;
  window.wombatStockCatalogStarted = true;
  const cache = new Map();
  let lastGrid;
  let run = 0;
  let activeCatalog;
  const baseURL = () => {
    const url = new URL(location.href);
    url.searchParams.delete('page');
    url.searchParams.delete('section_id');
    return url;
  };
  const pageURL = (page) => {
    const url = baseURL();
    if (page > 1) url.searchParams.set('page', page);
    return url.pathname + url.search + '#product-grid';
  };
  async function fetchPage(base, page, signal) {
    const url = new URL(base);
    url.searchParams.set('section_id', 'wombat-stock-catalog');
    url.searchParams.set('page', page);
    const response = await fetch(url, { signal, credentials: 'same-origin' });
    if (!response.ok) throw new Error('Catalog response failed');
    // A template keeps off-page images and scripts inert until a card is shown.
    const holder = document.createElement('template');
    holder.innerHTML = await response.text();
    const data = holder.content.querySelector('[data-wombat-catalog-page]');
    if (!data || Number(data.dataset.wombatCatalogPage) !== page) throw new Error('Invalid catalog page');
    return { total: Number(data.dataset.total), pages: Number(data.dataset.pages), cards: Array.from(data.querySelectorAll('template[data-product-id]')) };
  }
  async function loadCatalog(base) {
    const key = base.href;
    const cached = cache.get(key);
    if (cached && Date.now() - cached.time < 60000) return cached.cards;
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 25000);
    try {
      const first = await fetchPage(base, 1, controller.signal);
      const cards = [...first.cards];
      for (let page = 2; page <= first.pages; page++) {
        const next = await fetchPage(base, page, controller.signal);
        if (next.total !== first.total) throw new Error('Catalog changed during loading');
        cards.push(...next.cards);
      }
      const ids = new Set(cards.map(card => card.dataset.productId));
      if (cards.length !== first.total || ids.size !== cards.length) throw new Error('Incomplete catalog');
      cards.sort((a, b) => Number(a.dataset.stockRank) - Number(b.dataset.stockRank));
      cache.set(key, { cards, time: Date.now() });
      return cards;
    } finally { clearTimeout(timeout); }
  }
  function render(cards, grid, perPage, shouldFocus = false) {
    const pages = Math.max(1, Math.ceil(cards.length / perPage));
    const requested = Number(new URL(location.href).searchParams.get('page')) || 1;
    const page = Math.min(pages, Math.max(1, requested));
    const fragment = document.createDocumentFragment();
    cards.slice((page - 1) * perPage, page * perPage).forEach(card => fragment.append(card.content.cloneNode(true)));
    grid.replaceChildren(fragment);
    const collection = grid.parentElement;
    collection.querySelectorAll('.pagination-wrapper,[data-stock-pagination]').forEach(el => el.remove());
    const nav = document.createElement('nav');
    nav.dataset.stockPagination = '';
    nav.className = 'wombat-stock-pagination';
    nav.setAttribute('aria-label', '商品目錄分頁');
    if (pages > 1) {
      const addLink = (target, label) => {
        const link = document.createElement('a');
        link.href = pageURL(target);
        link.textContent = label;
        if (target === page) link.setAttribute('aria-current', 'page');
        nav.append(link);
      };
      if (page > 1) addLink(page - 1, '上一頁');
      const shown = new Set([1, pages, page - 1, page, page + 1]);
      let previous = 0;
      [...shown].filter(n => n > 0 && n <= pages).sort((a, b) => a - b).forEach(n => {
        if (previous && n > previous + 1) { const gap = document.createElement('span'); gap.textContent = '…'; nav.append(gap); }
        addLink(n, String(n)); previous = n;
      });
      if (page < pages) addLink(page + 1, '下一頁');
      collection.append(nav);
    }
    grid.dataset.stockSorted = 'true';
    grid.dataset.catalogTotal = String(cards.length);
    const note = document.querySelector('[data-wombat-stock-note]');
    if (note) note.textContent = `現貨優先顯示，其餘依所選排序排列；預購與售罄商品仍可瀏覽。共 ${cards.length} 個商品。`;
    if (shouldFocus) { grid.tabIndex = -1; grid.focus({ preventScroll: true }); grid.scrollIntoView({ block: 'start', behavior: 'smooth' }); }
  }
  async function initialise() {
    const grid = document.querySelector('#product-grid');
    const component = document.querySelector('[data-wombat-stock-per-page]');
    if (!grid || !component || grid === lastGrid || !grid.matches('ul')) return;
    lastGrid = grid;
    const token = ++run;
    const base = baseURL();
    const perPage = Number(component.dataset.wombatStockPerPage) || 16;
    grid.setAttribute('aria-busy', 'true');
    const note = document.querySelector('[data-wombat-stock-note]');
    if (note) note.textContent = '正在依現貨庫存整理商品…';
    try {
      const cards = await loadCatalog(base);
      if (token !== run || !grid.isConnected || base.href !== baseURL().href) return;
      activeCatalog = { cards, grid, perPage, key: base.href };
      render(cards, grid, perPage);
    } catch (error) {
      if (token === run && note) note.textContent = '現貨排序暫時無法載入，目前顯示原始商品目錄；請重新整理再試。';
      console.warn('Inventory-aware catalog:', error.message);
    } finally { grid.removeAttribute('aria-busy'); }
  }
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-stock-pagination] a');
    if (!link || !activeCatalog || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    history.pushState({ ...history.state }, '', link.href);
    render(activeCatalog.cards, activeCatalog.grid, activeCatalog.perPage, true);
  });
  window.addEventListener('popstate', () => {
    if (activeCatalog && activeCatalog.grid.isConnected && activeCatalog.key === baseURL().href) render(activeCatalog.cards, activeCatalog.grid, activeCatalog.perPage);
  });
  const start = () => {
    const root = document.querySelector('[data-wombat-stock-per-page]');
    if (!root) return;
    new MutationObserver(initialise).observe(root, { childList: true, subtree: true });
    initialise();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
})();
